var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report__list_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: 'name',
                title: 'Name',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'area',
                title: 'Area',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'description',
                title: 'Description',
                type: 'string'
            },
            {
                key: 'actions',
                title: '',
                type: 'string',
                sortable: false
            }
        ],"items":_vm.items,"component-table-item":_vm.ReportListTableItem,"component-table-collapse-item":_vm.ReportListTableItemCollapseTable,"component-table-collapse-item-active":_vm.activeCollapseIndex,"sort-queryable":_vm.sortQueryable},on:{"emit-sort":_vm.handleSort,"emit-collapse":_vm.handleCollapse}}),_c('a',{staticClass:"report__list_table_hiddenlink hidden",attrs:{"id":"download-report-csv"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }